import * as React from "react";
import {HashRouter, Route, Routes} from "react-router-dom";
import {UserMenu} from "./UserMenu";

import "./styles.scss";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../index";
import {EditUserImage, UserDetails} from "./UserDetails";
import {UserDetailsProvider} from "./contexts/UserDetailsContext";
import {VeboxUser} from "../providers/VeboxUser";
import {CommonDataProvider} from "./contexts/CommonDataProvider";
import {UsersDashboard} from "./users-dashboard/UsersDashboard";
import {UserActivitiesProvider} from "./contexts/UserActivitiesContext";
import {UserListProvider} from "./contexts/UserListContext";
import {UsersDashboardProvider} from "./contexts/UsersDashboardContext";
import {UserVisibilityHierarchiesProvider} from "./contexts/UserVisibilityHierarchiesContext";
import {UserCreation} from "../processes/user_creation/UserCreation";

export const GREEN = "#00C399";
export const RED = "#FC594D";

export const ACCESSES_COLOR = '#3B8281';
// export const ACCESSES_COLOR = '#6D87C3';
export const NOT_ACCESSES_COLOR = '#878787';

export enum VISIBILITY_TREE_ICONS {
    placed = "account_circle",
    visibility = "visibility",
    ceasedCompany = "warning"
}

export const ETUI_ICONS_SIZE = 24;

export const UserManagement: React.FC = () => {
    return (
        <ThemeProvider theme={veboxDefaultTheme}>
            <VeboxUser.Provider>
                <CommonDataProvider>
                    <UserListProvider>
                        <UsersDashboardProvider>
                            <HashRouter basename={"/"}>
                                <div className={"flx-row fill-parent"}>
                                    <UserMenu/>
                                    <div className={"fill-parent"}>
                                        <Routes>
                                            <Route
                                                path={"/"}
                                                element={
                                                    // User management dashboard*
                                                    <UsersDashboard/>
                                                }
                                            />
                                            <Route
                                                path={"/:userGuid"}
                                                element={
                                                    // User details
                                                    <UserDetailsProvider>
                                                        <UserActivitiesProvider>
                                                            <UserVisibilityHierarchiesProvider>
                                                                <UserDetails/>
                                                            </UserVisibilityHierarchiesProvider>
                                                        </UserActivitiesProvider>
                                                    </UserDetailsProvider>
                                                }
                                            >
                                                <Route
                                                    path={"editPicture"}
                                                    element={<EditUserImage/>}
                                                />
                                            </Route>
                                            <Route
                                                path={"/userCreation"}
                                                element={
                                                    // User creation
                                                    <UserCreation/>
                                                }
                                            />
                                        </Routes>
                                    </div>
                                </div>
                            </HashRouter>
                        </UsersDashboardProvider>
                    </UserListProvider>
                </CommonDataProvider>
            </VeboxUser.Provider>
        </ThemeProvider>
    );
}


const Placeholder: React.FC = (props) => {
    return (
        <div className={"fill-parent centered"} style={{background: "white", color: "black"}}>
            {props.children}
        </div>
    )
}